import { useMutation } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const registerLiveAttendance = async (data) => {
  const body = new FormData();
  body.append(
    "dados",
    `[${JSON.stringify({
      liveid: data.liveId,
      alunoid: _cookies.getItem("auth").user.alunoid,
    })}]`
  );
  const res = await axios.middleware.post(
    "/aluno.asmx/Registra_presenca_LIVE",
    body
  );
  return res;
};

export const useRegisterLiveAttendance = ({ config } = {}) => {
  return useMutation({ ...config, mutationFn: registerLiveAttendance });
};
